import React, { type ReactElement, type ReactNode } from 'react';

import classNames from 'classnames';

export interface LabelValueProps {
  children: ReactNode;
  className?: string;
}

export default function LabelValue({
  children,
  className,
}: LabelValueProps): ReactElement {
  return (
    <div
      className={classNames(
        'flex w-full items-center justify-between lg:py-3',
        className
      )}
    >
      {children}
    </div>
  );
}

function Label({ children, className }: LabelValueProps): ReactElement {
  return (
    <div
      className={classNames(
        'text-xs font-normal text-black-300 lg:text-sm lg:font-semibold lg:text-black-default',
        className
      )}
    >
      {children}
    </div>
  );
}

function Value({ children, className }: LabelValueProps): ReactElement {
  return (
    <div
      className={classNames(
        'text-xs font-medium text-black-400 lg:text-sm lg:font-semibold lg:text-black-300',
        className
      )}
    >
      {children}
    </div>
  );
}

LabelValue.Label = Label;
LabelValue.Value = Value;
